export default __webpack_public_path__ + "static/media/852.39512c99.png";